import { Button } from "@/shared/components";
import { useTanstackDevToolsInProduction } from "@/shared/hooks/use-tanstack-devtools-production.ts";

export function EnableTanstackDevToolsInProd() {
    const [devToolsEnabled, setDevToolsEnabled] = useTanstackDevToolsInProduction();
    const canEnabledProdDevTools = import.meta.env.MODE !== "development";

    return (
        <>
            <h3 className="text-l text-content-emphasis">TanStack Query DevTools</h3>
            <div>
                <Button
                    variant="secondary"
                    icon="ai-assistent"
                    onClick={() => setDevToolsEnabled((prev) => !prev)}
                    disabled={!canEnabledProdDevTools}
                >
                    Zet TanStack Query DevTools
                    {devToolsEnabled ? " uit" : " aan"}
                </Button>
            </div>
        </>
    );
}
